import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDateFormats,
} from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import {
  MAT_PAGINATOR_DEFAULT_OPTIONS,
  MatPaginatorIntl,
} from '@angular/material/paginator';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideEnvironmentNgxMask } from 'ngx-mask';

import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { CustomDateAdapter } from './shared/adapters/custom-date-adapter';
import { CustomIconRegistryService } from './shared/services/custom-icon-registry.service';
import PaginatorIntl from './shared/utils/paginator-intl';

export const BR_DATE_FORMATS: MatDateFormats = {
  parse: {
    // Obs: com NativeDateAdapter, o parse pode não respeitar 100% esse formato ao digitar manualmente
    dateInput: 'dd/MM/yyyy',
  },
  display: {
    // Força 2 dígitos (ex: 05/02/2026) quando o locale é pt-BR
    dateInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: '2-digit' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),

    // Registrar ícones SVG customizados antes da inicialização (forma moderna)
    provideAppInitializer(() => {
      const iconRegistry = inject(CustomIconRegistryService);
      return iconRegistry.registerIcons();
    }),

    // Por padrão o MAT_DATE_LOCALE herda do LOCALE_ID, mas deixar explícito evita surpresa
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    // Usar CustomDateAdapter para fazer parsing correto de DD/MM/YYYY
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: BR_DATE_FORMATS },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: 'short' },
    },
    {
      provide: MatPaginatorIntl,
      useClass: PaginatorIntl,
    },
    {
      provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
      useValue: { pageSizeOptions: [5, 10, 20, 50] },
    },
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideEnvironmentNgxMask(),
  ],
};
